import { Link } from 'react-router-dom'
import styled from 'styled-components'

import { COLOR } from '@/shared/constant/color'
import { customMedia } from '@/styles/common/common'

const UserPageWrap = styled.div`
  display: block;
  ${customMedia.lessThan('tablet')`
    max-width: 600px;
    width:100%;
    margin: 0 auto;
  `}
`
const UserPageTab = styled.div`
  margin: 64px 0 40px 0;
  line-height: 48px;
  height: 48px;
  display: flex;
  ${customMedia.lessThan('tablet')`
    margin: 24px 0 26px 0;
    line-height: 32px;
    height: 32px;
  `}
`

const UserPageTabContent = styled(Link)<{ active: string }>`
  font-size: 20px;
  line-height: 48px;
  font-family: NanumSquareNeoHeavy, sans-serif;
  color: ${(props) => (props.active === 'true' ? COLOR.point1 : COLOR.gray40)};
  background: ${COLOR.point2};
  border-radius: 30px;
  margin-right: 12px;
  width: 136px;
  text-align: center;
  ${customMedia.lessThan('tablet')`
    font-size: 14px;
    width: 92px;
    line-height: 32px;
    margin-right: 4px;
  `}
`

export { UserPageTab, UserPageTabContent, UserPageWrap }
